import type { IControllerConstructor, Injectable } from "angular";
import { TagComponentController } from "./TagComponentController";

import "./Tag.html";
import "./Tag.scss";

export class TagComponent {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {};
        this.controller = TagComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Tag/Tag.html";

        this.transclude = true;
    }
}
